import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SECTIONS = [
  {
    title: '1. Who we are',
    body: 'Transformerus is operated by GET Corp LP (“we”, “us”), a limited partnership registered in the United Kingdom. We are the data controller for personal information processed through the Service. You can contact us at support@transformerus.app.',
  },
  {
    title: '2. What we collect',
    body: 'We collect: (a) account data — name, email, profile picture and Google sub-id when you sign in; (b) usage data — chat prompts, generated outputs, build session metadata, and credits balance; (c) payment data — customer id, charge id, last4 and country of card, all handled by Stripe and never stored on our servers; (d) referral data — referral codes you create or use; (e) support data — messages you send via the contact form.',
  },
  {
    title: '3. How we use it',
    body: 'We use your personal information to: provide and improve the Service, deliver builds, route AI model calls, process payments, prevent fraud, send service-related emails, and comply with legal obligations. We do not sell your personal information.',
  },
  {
    title: '4. Legal bases (UK / EU GDPR)',
    body: 'We rely on: (a) performance of a contract to provide the Service you signed up for; (b) legitimate interests for fraud prevention, analytics, and product improvement; (c) consent for non-essential cookies and marketing emails; (d) legal obligation for tax and regulatory record-keeping.',
  },
  {
    title: '5. Sharing',
    body: 'We share data only with sub-processors strictly necessary to operate the Service: Stripe and PayPal (payments), MongoDB Atlas (database), OpenAI / Anthropic / Google (model inference for prompts you submit), Google (authentication), and our hosting provider. Each is contractually bound to comparable data protection standards.',
  },
  {
    title: '6. International transfers',
    body: 'Some of our sub-processors are located in the United States. Where personal data is transferred outside the UK / EEA, we rely on Standard Contractual Clauses or equivalent safeguards.',
  },
  {
    title: '7. Retention',
    body: 'Account and billing records are retained for the lifetime of your account plus 7 years to comply with UK accounting law. Chat prompts and generated outputs are retained for 90 days unless you delete them earlier. Anonymous traffic logs are retained for 30 days.',
  },
  {
    title: '8. Your rights',
    body: 'Under UK / EU GDPR you have the right to access, rectify, delete, restrict, object to, or port your personal data, and to withdraw consent at any time. Email support@transformerus.app to exercise any of these. You also have the right to lodge a complaint with the UK Information Commissioner’s Office (ico.org.uk).',
  },
  {
    title: '9. Cookies',
    body: 'We use first-party cookies for authentication (httpOnly session_token, 7-day lifetime) and a small amount of localStorage to track an anonymous browser session, your referral code, and pending referral attribution. We do not use third-party advertising cookies.',
  },
  {
    title: '10. Security',
    body: 'We use TLS in transit, encryption at rest on the database, scoped API keys, and least-privilege access for our team. No system is perfectly secure; if we discover a breach affecting your data we will notify you within 72 hours where required by law.',
  },
  {
    title: '11. Children',
    body: 'The Service is not intended for individuals under 18. If you believe a minor has created an account, contact us and we will delete it.',
  },
  {
    title: '12. Changes',
    body: 'We will post material changes to this policy at /privacy and notify registered users by email. Continued use of the Service after the effective date constitutes acceptance.',
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 pt-28 pb-24">
        <div className="mx-auto max-w-3xl px-6">
          <span className="inline-flex px-3 py-1 rounded-full bg-neutral-100 text-xs font-medium text-neutral-700">Legal</span>
          <h1 className="font-display text-4xl lg:text-5xl font-bold text-neutral-900 tracking-tight mt-4">Privacy Policy</h1>
          <p className="mt-3 text-neutral-500 text-sm">Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long' })}</p>

          <div className="mt-10 space-y-8">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="font-display text-xl font-semibold text-neutral-900">{s.title}</h2>
                <p className="mt-2 text-neutral-700 leading-relaxed">{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
